import * as SITE from "../data/site";
import { PRO_PAGES, PRO_SPOTLIGHT } from "../data/prosPages";

const API = process.env.REACT_APP_BACKEND_URL;

// keys -> the mutable default objects in data/site.js (overridden in place so every consumer sees the edits)
export const CONTENT_TARGETS = {
  contact: SITE.CONTACT,
  brand: SITE.BRAND,
  footer: SITE.FOOTER,
  cta: SITE.CTA,
  home: SITE.HOME,
  showroom: SITE.SHOWROOM_PAGE,
  contactPage: SITE.CONTACT_PAGE,
  testimonialsPage: SITE.TESTIMONIALS_PAGE,
  privacy: SITE.PRIVACY,
  projectsPage: SITE.PROJECTS_PAGE,
  nav: SITE.NAV,
  architects: PRO_PAGES["/architects/"],
  developers: PRO_PAGES["/developers/"],
  quantitySurveyors: PRO_PAGES["/quantity-surveyors/"],
  spotlight: PRO_SPOTLIGHT,
};
// array-valued content
export const CONTENT_LISTS = {
  locations: SITE.LOCATIONS,
  testimonials: SITE.TESTIMONIALS,
  brandLogos: SITE.BRAND_LOGOS,
};

export const DEFAULTS = JSON.parse(JSON.stringify({ ...CONTENT_TARGETS, ...CONTENT_LISTS }));

const phoneHref = (p) => `tel:${String(p || "").replace(/[^\d+]/g, "")}`;

const replaceArray = (target, next) => {
  if (!Array.isArray(next)) return;
  target.splice(0, target.length, ...next);
};

export const applyContent = (remote) => {
  Object.entries(remote || {}).forEach(([key, data]) => {
    if (!data || typeof data !== "object") return;
    if (CONTENT_LISTS[key]) {
      replaceArray(CONTENT_LISTS[key], Array.isArray(data) ? data : data.items);
      return;
    }
    const target = CONTENT_TARGETS[key];
    if (!target) return;
    Object.entries(data).forEach(([k, v]) => {
      if (Array.isArray(v) && Array.isArray(target[k])) replaceArray(target[k], v);
      else target[k] = v;
    });
    if (key === "contact" && data.phone) target.phoneHref = phoneHref(data.phone);
  });
};

let loadPromise = null;
export const initSiteContent = (onLate) => {
  if (loadPromise) return loadPromise;
  let settled = false;
  const fetchP = fetch(`${API}/api/site-content`)
    .then((r) => r.json())
    .then((d) => {
      applyContent(d);
      try { sessionStorage.setItem("cv-content", JSON.stringify({ t: Date.now(), d })); } catch {}
      if (settled && onLate) onLate();
    })
    .catch(() => {});
  try {
    const cached = JSON.parse(sessionStorage.getItem("cv-content") || "null");
    if (cached && Date.now() - cached.t < 60000) { applyContent(cached.d); loadPromise = Promise.resolve(); return loadPromise; }
  } catch {}
  loadPromise = Promise.race([fetchP, new Promise((res) => setTimeout(res, 1500))]).then(() => { settled = true; });
  return loadPromise;
};
